// Chart 1: 월 현금흐름 갭 — port of make_waterfall()
import usePlotly from './usePlotly';
import { toManwon } from '../../lib/format';

export default function WaterfallChart({ target, nps, gap }) {
  const ref = usePlotly(() => ({
    data: [{
      type: 'waterfall',
      orientation: 'v',
      measure: ['absolute', 'relative', 'total'],
      x: ['희망 월 수익', '국민연금', '필요 현금흐름(갭)'],
      y: [toManwon(target), -toManwon(nps), toManwon(gap)],
      connector: { line: { color: '#ead9c7', width: 1 } },
      increasing:  { marker: { color: '#9a6338' } },
      decreasing:  { marker: { color: '#f28b82' } },
      totals:      { marker: { color: '#7a451f' } },
      textposition: 'outside',
      text: [
        toManwon(target).toFixed(0) + '만',
        (-toManwon(nps)).toFixed(0) + '만',
        toManwon(gap).toFixed(0) + '만',
      ],
    }],
    layout: {
      title: { text: '월 현금흐름 갭 (희망 수익 - 국민연금)', font: { size: 13 } },
      height: 380,
      yaxis: { ticksuffix: '만원', tickformat: '.0f', gridcolor: '#ead9c7', zerolinecolor: '#ead9c7' },
      xaxis: { gridcolor: '#ead9c7' },
    },
  }), [target, nps, gap]);

  return <div ref={ref} style={{ width: '100%' }} />;
}
